import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "../../../../../styles/_common.scss";
// import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import Pagination from "../../../../../components/ui/Pagination";
import RadioButton from "../../../../../components/ui/RadioButton";
import Button from "../../../../../components/ui/Button";

import { formatNumber } from "../../../../../utils/util";
import { searchIcon, filterIcon } from "../../../../../utils/icons";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyRiskStats, resetThirdPartyRiskStats, getIpAddressList, resetIpAddressList } from "../../../../../store/actions/thirdPartyRiskAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const SecurityOverviewIpAddress = () => {

    const ipAddressStatsResponse = useSelector((state) => state.thirdPartyRisk?.thirdPartyRiskStats);
    const ipAddressListResponse = useSelector((state) => state.thirdPartyRisk?.ipAddressList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [scanNotFound, setScanNotFound] = useState(false);
    const [ipAddressStats, setIpAddressStats] = useState("");
    const [statsLoading, setStatsLoading] = useState(false);

    const [isLoading, setIsLoading] = useState(false)
    const [ipAddressList, setIpAddressList] = useState(null);
    const [showSubdomainListModal, setShowSubdomainListModal] = useState(false);
    const [subdomainList, setSubdomainList] = useState(null);

    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedRiskyPortType, setSelectedRiskyPortType] = useState("");
    const [selectedBlacklisted, setSelectedBlacklisted] = useState("");
    const [selectedCompromised, setSelectedCompromised] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
            riskyPort: selectedRiskyPortType,
            blacklisted: selectedBlacklisted,
            compromised: selectedCompromised,
        }
        setSelectedFilterValue(obj)
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1); 
        setSelectedFilterValue({})
        setNewFindingsType("")
        setSelectedRiskyPortType("")
        setSelectedBlacklisted("")
        setSelectedCompromised("")
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const fetchSimilarDomainStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.thirdPartyRisk.securityOverview.ipAddress.ipAddressStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getThirdPartyRiskStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const fetchIpAddressList = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const riskyPort = selectedFilterValue.riskyPort && selectedFilterValue.riskyPort !== "all" ? `&risky_port=${selectedFilterValue.riskyPort === "yes" ? true : false}` : "";
        const blacklisted = selectedFilterValue.blacklisted && selectedFilterValue.blacklisted !== "all" ? `&blacklisted=${selectedFilterValue.blacklisted === "yes" ? true : false}` : "";
        const compromised = selectedFilterValue.compromised && selectedFilterValue.compromised !== "all" ? `&compromised=${selectedFilterValue.compromised === "yes" ? true : false}` : ""; 
        const url = `${baseUrl}${params}${queryParams}${newFindings}${riskyPort}${blacklisted}${compromised}`
        dispatch(getIpAddressList(url))
    },[domainId, organizationId, scanId, currentPage, currentPageSize, searchQuery, selectedFilterValue, dispatch])


    useEffect(()=>{
        fetchIpAddressList()
    },[currentPage, fetchIpAddressList])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchSimilarDomainStats()
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchSimilarDomainStats])

    useEffect(()=>{
        if(ipAddressStatsResponse !== null) {
            setStatsLoading(false)
            setIpAddressStats(ipAddressStatsResponse)
            dispatch(resetThirdPartyRiskStats())
        }
    },[ipAddressStatsResponse, dispatch])

    useEffect(()=>{
        if(ipAddressListResponse != null) {
            setIpAddressList(ipAddressListResponse)
            if(ipAddressListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetIpAddressList())
            setIsLoading(false)
        }
    },[ipAddressListResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        }
    },[showFilter])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            <div className="discover-doamin-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">IP Addresses</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(ipAddressStats?.stats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="discover-doamin-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"ipaddress"} />
                                    :
                                    <motion.div
                                        className="h-100"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                            <div className="header-content d-flex justify-content-between">
                                                <p className="heading">IP Addresses</p>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <div className="total-score-container rounded">
                                                    <div className="users-totol-count d-flex">
                                                        <p className="total-score-count">{formatNumber(ipAddressStats?.stats?.reputation_type?.total)}</p>
                                                        <div className="score-count mx-3">
                                                            <span className="new-record blacklisted-ip d-inline-block mx-1"></span>
                                                            <span className="existing-record compromised-ip d-inline-block"></span>
                                                            <p>Total IP Addresses</p>
                                                        </div>
                                                    </div>
                                                    <div className="new-exist-count d-flex gap-4 mt-3">
                                                        <p className="new-record blacklisted-ip"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.reputation_type?.blacklisted)}</span> Blacklisted IPs</p>
                                                        <p className="existing-record compromised-ip"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.reputation_type?.compromised)}</span> Non-Blacklisted IPs</p>
                                                    </div>
                                                </div>
                                            </div>
                                    </motion.div>
                                }
                            </div>                           
                        </Col>                                                
                        <Col lg={4}>
                            <div className="discover-doamin-container ports-container rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"ipaddress"} />
                                    :
                                    <motion.div
                                        className="h-100"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                            <div className="header-content d-flex justify-content-between">
                                                <p className="heading">Ports</p>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <div className="total-score-container rounded">
                                                    <div className="users-totol-count d-flex">
                                                        <p className="total-score-count">{formatNumber(ipAddressStats?.stats?.port_type?.total)}</p>
                                                        <div className="score-count mx-3">
                                                            <span className="new-record risky-port d-inline-block mx-1"></span>
                                                            <span className="existing-record non-risky-port d-inline-block"></span>
                                                            <p>Total Open Ports</p>
                                                        </div>
                                                    </div>
                                                    <div className="new-exist-count d-flex gap-4 mt-3">
                                                        <p className="new-record risky-port"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.port_type?.risky_port)}</span> Risky Ports</p>
                                                        <p className="existing-record non-risky-port"><span className="d-inline-block">{formatNumber(ipAddressStats?.stats?.port_type?.non_risky_port)}</span> Non-Risky Ports</p>
                                                    </div>
                                                </div>
                                            </div>
                                    </motion.div>
                                }
                            </div>                            
                        </Col>
                    </Row>
                </div>
                <div className="domain-similarities-container git-leaks-main-content bg-white-with-shadow p-3 mt-3">
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search"
                                    value={searchValue} 
                                    onChange={(e)=>{
                                        setSearchValue(e.target.value)
                                    }}
                                    onFocus={() => setIsSearchFocused(true)}
                                    onBlur={() => setIsSearchFocused(false)}
                                />
                            </div>
                            <button className="search-btn" onClick={onSearch}>Search</button>
                        </div>                        
                        <div className="position-relative">
                            <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                <h6>New Findings</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={`new-${index}`} isChecked={data.value === newFindingsType} />
                                            )
                                        })
                                    }
                                </div>
                                <h6>Risky Port</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={`risky-port-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedRiskyPortType(value)}} key={`risky-${index}`} isChecked={data.value === selectedRiskyPortType} />
                                            )
                                        })
                                    }
                                </div>
                                <h6>Blacklisted</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={`blacklisted-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedBlacklisted(value)}} key={`black-${index}`} isChecked={data.value === selectedBlacklisted} />
                                            )
                                        })
                                    }
                                </div>
                                <h6>Compromised</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={`compromised-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedCompromised(value)}} key={`compare-${index}`} isChecked={data.value === selectedCompromised} />
                                            )
                                        })
                                    }
                                </div>
                                <div className="filter-apply-btn mt-3">
                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div className="table-container js-secrets-table mt-4">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"subDomain"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>IP Address</th>
                                        <th>Subdomain</th>
                                        <th>Ports/Risky Ports</th>
                                        <th>Country</th>
                                        <th>Hosting</th>
                                        <th>Organization</th>
                                        <th>AS Details</th>
                                    </tr>                                
                                </thead>
                                <tbody>
                                    {
                                        ipAddressList?.results?.length > 0 &&
                                        ipAddressList?.results.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td>
                                                        <p className="dns-record-subdomain mb-2">{data?.ip_address}</p>
                                                        <span className="d-block dns-record-domain">{data?.domain}</span>
                                                        {data?.new_record && <span className="d-inline-block new-data mr-2">New</span>}
                                                        <div className="ip-address-status">
                                                            {data?.blacklisted?.is_blacklisted && <span className="status blacklisted">Blacklisted</span>}
                                                            {data?.compromised?.is_compromised && <span className="status compromised">Compromised</span>}
                                                        </div>
                                                    </td>
                                                    <td className="subdomain-ip-container">                                                        
                                                        {data?.subdomains.length > 0 ?
                                                            data?.subdomains.map((subdoamin, index)=>{
                                                                if(index <= 2) {
                                                                    return (
                                                                        <div className={`subdomain-section d-flex mb-2 ${data?.subdomains?.length > 1 ? "border-bottom" : ""}`} key={index}>
                                                                            <div className="subdomain">
                                                                                <p className="subdomain-name">{subdoamin?.subdomain}</p>
                                                                                <div className="http-status">
                                                                                    {!subdoamin?.http_status?.http && <span className="status inactive">HTTP Inactive</span>}
                                                                                    {subdoamin?.http_status?.http && <span className="status active">HTTP Active</span>}
                                                                                    {!subdoamin?.http_status?.https && <span className="status inactive">HTTPS Inactive</span>}
                                                                                    {subdoamin?.http_status?.https && <span className="status active">HTTPS Active</span>}
                                                                                </div>
                                                                            </div>
                                                                            <div className="subdomain-type">
                                                                                <p className="text-capitalize">{subdoamin?.subdomain_type}</p>                                                                            
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                            :
                                                            "-"
                                                        }
                                                        {
                                                            data?.subdomains?.length > 3 && <p className="cursor-pointer view-all mb-4" onClick={()=>{
                                                                setSubdomainList(data)
                                                                setShowSubdomainListModal(true)
                                                            }}>{`+${data?.subdomains?.length - 3}`} view all</p>
                                                        }
                                                    </td>
                                                    <td className="status-container">
                                                        {data?.ports?.length > 0 &&
                                                            data?.ports?.map((data, index)=>{
                                                                return (
                                                                    <div className="d-inline-block mx-1 mb-2" key={index}>
                                                                        {data?.risky_port && <p className="status-open">{data?.port}</p>}
                                                                        {!data?.risky_port && <p className="status-close">{data?.port}</p>}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                    <td>{data?.country}</td>
                                                    <td>{data?.hosting_provider}</td>
                                                    <td>
                                                        <p className="dns-record-subdomain">{data?.organization}</p>
                                                    </td>
                                                    <td>
                                                        {data?.as_number}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        }
                        
                        { !isLoading && ipAddressList && !scanNotFound && ipAddressList?.results?.length > 0 &&
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={ipAddressList?.meta?.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />
                        }
                        {
                            !isLoading && !scanNotFound && ipAddressList !== "" && ipAddressList?.results?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                        {
                            !isLoading && scanNotFound && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={ipAddressList?.description} />
                            </motion.div>
                        }
                    </div>
                </div>
                <Modal
                    show={showSubdomainListModal}
                    onHide={()=>setShowSubdomainListModal(false)}
                    size="md"
                    centered
                    className=""
                    >
                        <Modal.Body>
                            <div className="delete-organization-container">
                                <h4 className="mb-3">Subdomains</h4>
                                <h4 className="mb-3">Total : {subdomainList?.subdomains?.length}</h4>
                                <div className="type-list-container"> 
                                    <div className="js-secrets-table">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Subdomain</th>
                                                    <th>Subdomain Type</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { 
                                                    subdomainList?.subdomains.map((data, index)=>{
                                                        return (
                                                            <motion.tr
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <td>
                                                                    <p>{data?.subdomain}</p>
                                                                    <div className="http-status">
                                                                        {!data?.http_status?.http && <span className="status inactive">HTTP Inactive</span>}
                                                                        {data?.http_status?.http && <span className="status active">HTTP Active</span>}
                                                                        {!data?.http_status?.https && <span className="status inactive">HTTPS Inactive</span>}
                                                                        {data?.http_status?.https && <span className="status active">HTTPS Active</span>}
                                                                    </div>
                                                                </td>
                                                                <td><p className="text-capitalize">{data?.subdomain_type}</p></td>
                                                            </motion.tr>
                                                        )
                                                    })                                                        
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <div className="w-50">
                                        <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowSubdomainListModal(false)}/>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                </Modal>
            </div>
        </>        
    )
}


export default SecurityOverviewIpAddress;